import { ExternalLink } from 'lucide-react';
import { cn } from '@/lib/utils';
import type { HackerSponsorsVercelV0 } from '@/types';

// /26-ar/vercel-v0 — Argentina's own perk page (app/(hack)/26-ar/(sponsors)/vercel-v0).
export default function VercelV0({
  couponCode,
  subtitle,
  titleFont,
}: HackerSponsorsVercelV0) {
  return (
    <div className="min-h-screen bg-background">
      <div className="container mx-auto px-4 py-12 md:py-16">
        <div className="mx-auto w-full max-w-4xl space-y-8">
          <div className="text-center">
            <h1
              className={cn(
                'inline-block font-bold text-2xl text-primary sm:text-3xl md:text-4xl',
                titleFont,
              )}
            >
              <span className="bg-primary px-2 py-1 text-background">
                VERCEL v0
              </span>
            </h1>
            <p
              className={cn(
                'mt-4 text-primary/70 text-sm uppercase tracking-wide',
                titleFont,
              )}
            >
              {subtitle}
            </p>
          </div>

          <div className="border-2 border-primary bg-background/80 p-6 backdrop-blur-sm sm:p-8 md:p-10">
            <div className="space-y-6">
              <div className="border-primary/20 border-b pb-4">
                <h2
                  className={cn(
                    'font-bold text-2xl text-primary sm:text-3xl md:text-4xl',
                    titleFont,
                  )}
                >
                  CRÉDITOS DE v0
                </h2>
                <p className={cn('mt-2 text-primary/70 text-sm', titleFont)}>
                  Vercel está apoyando a los hackers con acceso a v0.
                </p>
              </div>

              <div className="border-primary border-l-4 pl-4">
                <h3
                  className={cn(
                    'font-bold text-primary/70 text-sm uppercase',
                    titleFont,
                  )}
                >
                  Código de canje
                </h3>
                <p className="font-bold font-mono text-primary text-xl sm:text-2xl">
                  {couponCode}
                </p>
              </div>

              <a
                href="https://v0.app"
                target="_blank"
                rel="noopener noreferrer"
                className={cn(
                  'inline-flex items-center gap-2 border-2 border-primary bg-primary px-6 py-3 font-bold text-background uppercase tracking-wide transition-all hover:bg-background hover:text-primary',
                  titleFont,
                )}
              >
                Ir a v0
                <ExternalLink className="h-4 w-4" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
